export const typeFaults = {
  success: [
    'Paciente esqueceu a consulta',
    'Paciente reagendou',
    'Problema com o acesso/link',
    'Paciente cancelou',
  ],
  failed: ['Caixa postal', 'Não atendeu'],
};
